import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-450f79e2"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "count-up__instruction" }, "Count from 1 to 49", -1))
const _hoisted_2 = { class: "count-up__false-count-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_timer_box = _resolveComponent("timer-box")!
  const _component_game_matrix_display = _resolveComponent("game-matrix-display")!
  const _component_game_info_point = _resolveComponent("game-info-point")!
  const _component_game_wrapper = _resolveComponent("game-wrapper")!

  return (_openBlock(), _createBlock(_component_game_wrapper, {
    title: "Count Up",
    name: "CountUp",
    "is-game-over": _ctx.isGameOver,
    counter: _ctx.restartCounter,
    scoreElements: _ctx.scoreElements,
    onPrecountdownOver: _ctx.newRound,
    onRestart: _ctx.restart
  }, {
    top: _withCtx(() => [
      _createVNode(_component_timer_box, {
        class: "count-up__timer",
        timer: _ctx.gameTimer,
        threshold: _ctx.gameTimeThreshold
      }, null, 8, ["timer", "threshold"])
    ]),
    default: _withCtx(() => [
      _hoisted_1,
      _createVNode(_component_game_matrix_display, {
        class: "count-up__matrix",
        matrix: _ctx.gameMatrix,
        "has-disabled-style": true,
        "max-width": _ctx.matrixDisplayWidth,
        onItemClick: _ctx.confirmNumber
      }, null, 8, ["matrix", "max-width", "onItemClick"])
    ]),
    bottom: _withCtx(() => [
      _createElementVNode("div", _hoisted_2, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.falseCounts, (point) => {
          return (_openBlock(), _createBlock(_component_game_info_point, {
            key: point.id,
            value: point.value
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(point.info), 1)
            ]),
            _: 2
          }, 1032, ["value"]))
        }), 128))
      ])
    ]),
    _: 1
  }, 8, ["is-game-over", "counter", "scoreElements", "onPrecountdownOver", "onRestart"]))
}